import { LabKitClient, SampleSex } from "@app/api2/api";
import { SelectableItem, SelectableItemTyped, useSelectableList } from "./UseSelectableList";
import { useUser } from "../Contexts/UserContext";
import { queriesClient } from "@app/api2/Clients";
import { useTranslation2 } from "../Contexts/TranslationContext2";



interface UseKitListOptions {
  defaultId?: number;
  labId?: number;
  deps?: any[];
}

export function useKits({
  defaultId,
  labId,
  deps = [],
}: UseKitListOptions) {
  const kitClient = new LabKitClient();
  const user = useUser();

  const kits = useSelectableList<SelectableItem, number>({
    apiCall: () => {
      if (labId == null)
        return queriesClient.getKits().then(response => response.map(kit => ({ id: kit.id, value: kit.id, text: kit.fullName })));

      return kitClient.getAll(labId).then(response => response.map(kit => ({ id: kit.id, value: kit.id, text: kit.fullName })));
    },
    defaultId: defaultId ?? null,
    deps: [user, labId, defaultId, ...deps],
  });

  return kits;
}

export function useSex({defaultId}: {defaultId?: SampleSex; } = {}) {
  const { translations: t } = useTranslation2();
  const options = [{ type: SampleSex.Female, label: t.brutus.female }, { type: SampleSex.Male, label: t.brutus.male }]

  return useSelectableList<SelectableItemTyped<SampleSex>, SampleSex>({
    apiCall: async () => {
      return options.map((type) => {
        return {
          id: type.type, value: type.type, text: type.label
        };
      })
    },
    defaultId: defaultId ?? null,
    deps: [defaultId],
  });
}